import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { clientname, dataaccess, currentTenant, userid, currency, thousandsdisplay } from "../../Common/Credentials";
import PurchaseServices from "../PurchseServices";
import moment from "moment";
import { spin } from "../../Common/NewLoader";
import { purchaseid } from "../../Common/Permissions";
import { NumericFormat } from "react-number-format";
import { TextField, MenuItem, Tooltip } from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// Import icons
import ViewIcon from "../../images/Icons/preview.png";
import UpArrow from "../../images/Icons/up-arrow.png";

// Import CSS
import '../../NewUI/NewUI.css';
import Footer from "../../Component/Footer.js";
import Header from "../../Component/Header.js";
import Menu from "../../Component/Menu.js";

const TabButton = ({ active, onClick, children }) => (
  <fieldset
    onClick={onClick}
    className={`UI-tab-button ${active ? "UI-active-tab" : "UI-inactive-tab"}`}
    style={{
      cursor: "pointer",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      padding: "8px 16px",
      fontSize: "0.8rem",
      fontWeight: 500,
      textWrap: "nowrap",
    }}
  >
    {children}
    <img
      src={UpArrow}
      alt="Up Arrow"
      className="UI-tab-arrow"
      style={{
        transform: active ? "rotate(30deg)" : "rotate(0deg)",
      }}
    />
  </fieldset>
);

class PurchaseReturns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PurchaseReturnsData: [],
      GrnReturnsData: [],
      loading: false,
      returntype: "GRN Item Returns",
      fromdate: moment().subtract(7, "days"),
      todate: moment(),
      dateFilterApplied: true,

      // UI State
      isMobile: window.innerWidth <= 768,
      currentView: 'list',
      selectedReturn: null,
      searchTerm: "",
      showSearch: false,
      hovered: null,
      hoveredRow: null,
      isActionHovered: null,
      filteredData: [],
      filteredSidebarData: [],
      currentPage: 1,
      itemsPerPage: 20,
      hasScrolledToSelected: false,
      sortConfig: { key: 'supplier', direction: 'asc' },
      initialLoad: true,
      exportDropdownOpen: false
    };

    this.handleResize = this.handleResize.bind(this);
    this.refreshSalesorder = this.refreshSalesorder.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.handleDateFilter = this.handleDateFilter.bind(this);
    this.handlePreviousMonth = this.handlePreviousMonth.bind(this);
    this.handleClearFilter = this.handleClearFilter.bind(this);
    this.exportPDF = this.exportPDF.bind(this);
    this.toggleExportDropdown = this.toggleExportDropdown.bind(this);
    this.closeExportDropdown = this.closeExportDropdown.bind(this);
    this.handleReturnClick = this.handleReturnClick.bind(this);
    this.handleBackToList = this.handleBackToList.bind(this);
    this.renderTable = this.renderTable.bind(this);
    this.renderTypeTabs = this.renderTypeTabs.bind(this);
    this.renderDateFilters = this.renderDateFilters.bind(this);
    this.renderListView = this.renderListView.bind(this);
    this.renderDetailView = this.renderDetailView.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleItemsPerPageChange = this.handleItemsPerPageChange.bind(this);
    this.renderPagination = this.renderPagination.bind(this);
    this.sortData = this.sortData.bind(this);
    this.getSortedData = this.getSortedData.bind(this);
    this.formatCurrency = this.formatCurrency.bind(this);
    this.formatCurrencyAsString = this.formatCurrencyAsString.bind(this);
    this.highlightSearchText = this.highlightSearchText.bind(this);
    this.escapeRegex = this.escapeRegex.bind(this);
    this.getCurrentData = this.getCurrentData.bind(this);
    this.updateFilteredData = this.updateFilteredData.bind(this);
    this.getCurrentTypeLabel = this.getCurrentTypeLabel.bind(this);
    this.sidebarRef = React.createRef();
    this.scrollTimeout = null;
    this.exportRef = React.createRef();
  }

  // Sort indicator component
  SortIndicator = ({ columnKey }) => {
    if (this.state.sortConfig.key !== columnKey) {
      return <i className="fa fa-sort UI-sort-icon" />;
    }
    return this.state.sortConfig.direction === 'asc'
      ? <i className="fa fa-sort-up UI-sort-icon UI-sort-active" />
      : <i className="fa fa-sort-down UI-sort-icon UI-sort-active" />;
  }

  // Sorting function
  sortData(key) {
    let direction = 'asc';
    if (this.state.sortConfig.key === key && this.state.sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    this.setState({ sortConfig: { key, direction } });
  }

  getSortedData(data) {
    if (!this.state.sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      switch (this.state.sortConfig.key) {
        case 'supplier':
          aValue = a.supplier || '';
          bValue = b.supplier || '';
          break;
        case this.state.returntype === "Purchase Returns" ? 'custompoid' : 'customgrnid':
          aValue = this.state.returntype === "Purchase Returns" ? a.custompoid || '' : a.customgrnid || '';
          bValue = this.state.returntype === "Purchase Returns" ? b.custompoid || '' : b.customgrnid || '';
          break;
        case 'date':
          aValue = new Date(a.date).getTime();
          bValue = new Date(b.date).getTime();
          break;
        case 'totalprice':
          aValue = Number(a.totalprice) || 0;
          bValue = Number(b.totalprice) || 0;
          break;
        default:
          aValue = a[this.state.sortConfig.key] || '';
          bValue = b[this.state.sortConfig.key] || '';
      }

      if (aValue < bValue) {
        return this.state.sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return this.state.sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  escapeRegex(string) {
    if (!string) return '';
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlightSearchText(text, searchTerm) {
    if (!searchTerm?.trim() || !text) return text;

    const rawText = String(text);
    const escapedSearchTerm = this.escapeRegex(searchTerm);

    if (escapedSearchTerm.length > 50) {
      return rawText;
    }

    try {
      const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
      const parts = rawText.split(regex);

      return parts.map((part, index) =>
        regex.test(part)
          ? React.createElement('mark', {
            key: index,
            className: 'UI-search-highlight'
          }, part)
          : part
      );
    } catch (error) {
      console.warn('Regex error in search:', error);
      return rawText;
    }
  }

  formatCurrency(value) {
    if (value === null || value === undefined) return '0';
    const numericValue = typeof value === 'object' && value.parsedValue !== undefined ? value.parsedValue : value;

    const prefix = currency === "INR" ? "₹ " : currency === "USD" ? "$ " : currency + " ";

    return (
      <NumericFormat
        displayType="text"
        value={numericValue}
        decimalScale={2}
        fixedDecimalScale={true}
        thousandSeparator={true}
        thousandsGroupStyle={thousandsdisplay}
        prefix={prefix.trim()}
      />
    );
  }

  formatCurrencyAsString(value) {
    if (value === null || value === undefined) return '0.00';
    const numericValue = typeof value === 'object' && value.parsedValue !== undefined ? value.parsedValue : value;

    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue);
  }

  handleResize() {
    const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile });
    if (!isMobile) {
      this.setState({ showSearch: false });
    }
  }

  componentDidMount() {
    if (window.innerWidth <= 768) {
      this.setState({ showSearch: true });
    }
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleClickOutside);

    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }
    this.setState({ loading: true });
    this.refreshSalesorder();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.currentView === 'detail' &&
      this.state.selectedReturn &&
      this.sidebarRef.current &&
      !this.state.hasScrolledToSelected) {

      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      this.scrollTimeout = setTimeout(() => {
        const selectedElement = this.sidebarRef.current.querySelector(
          `[data-return-id="${this.state.selectedReturn.id ||
          (this.state.returntype === "Purchase Returns" ? this.state.selectedReturn.poid : this.state.selectedReturn.grnid)}"]`
        );
        if (selectedElement) {
          selectedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.setState({ hasScrolledToSelected: true });
        }
      }, 100);
    }

    if (prevState.currentView !== this.state.currentView && this.state.currentView === 'list') {
      this.setState({ hasScrolledToSelected: false });
    }

    if (prevState.returntype !== this.state.returntype) {
      this.updateFilteredData();
    }

    if (prevState.selectedReturn !== this.state.selectedReturn) {
      this.setState({ hasScrolledToSelected: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleClickOutside);
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  }

  handleClickOutside = (event) => {
    if (this.exportRef.current && !this.exportRef.current.contains(event.target)) {
      this.setState({ exportDropdownOpen: false });
    }
  };

  refreshSalesorder() {
    const datadao = {
      tenantid: currentTenant,
      startdate: this.state.fromdate,
      enddate: this.state.todate,
      userid: userid,
      dataaccess: dataaccess,
    };

    this.setState({ loading: true });

    // Fetch Purchase Returns
    PurchaseServices.GetPurchaseReturns(datadao)
      .then((response) => {
        this.setState({
          PurchaseReturnsData: response.data.map(item => ({
            ...item,
            id: item.poid,
            type: 'Purchase Return'
          }))
        }, () => {
          this.updateFilteredData();
        });
      })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });

    // Fetch GRN Returns
    PurchaseServices.GetGrnReturns(datadao).then((res) => {
      this.setState({
        GrnReturnsData: res.data.map(item => ({
          ...item,
          id: item.grnid,
          type: 'GRN Return'
        }))
      }, () => {
        this.updateFilteredData();
      });
    });
  }

  updateFilteredData() {
    const { searchTerm, returntype, PurchaseReturnsData, GrnReturnsData } = this.state;

    let data = [];
    if (returntype === "Purchase Returns") {
      data = PurchaseReturnsData;
    } else {
      data = GrnReturnsData;
    }

    if (!searchTerm.trim()) {
      this.setState({
        filteredData: data,
        filteredSidebarData: this.state.currentView === 'detail' ? data : data,
        currentPage: 1,
        loading: false
      });
      return;
    }

    const cleanSearch = searchTerm.replace(/[^\w₹$€]/g, '').toLowerCase();

    const filtered = data.filter((item) => {
      const checkFields = [
        item.supplier,
        returntype === "Purchase Returns" ? item.custompoid : item.customgrnid,
        item.date?.toString(),
      ];

      return checkFields.some((field) => {
        if (field === undefined || field === null) return false;

        const raw = String(field);
        const cleanField = raw.replace(/[^\w₹$€]/g, '').toLowerCase();

        return (
          cleanField.includes(cleanSearch) ||
          raw.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
    });

    this.setState({
      filteredData: filtered,
      filteredSidebarData: this.state.currentView === 'detail' ? filtered : data,
      currentPage: 1,
      loading: false
    });
  }

  handleSearch(term) {
    this.setState({ searchTerm: term }, () => {
      this.updateFilteredData();
    });
  }

  getCurrentData() {
    if (this.state.returntype === "Purchase Returns") return this.state.PurchaseReturnsData;
    return this.state.GrnReturnsData;
  }

  handleFromDateChange = (date) => {
    this.setState({
      fromdate: date,
      todate: moment(date).diff(this.state.todate, "days") >= 0
        ? this.state.todate
        : date,
    });
  };

  handleToDateChange = (date) => {
    this.setState({ todate: date });
  };

  handleDateFilter = () => {
    this.setState({ dateFilterApplied: true }, () => {
      this.refreshSalesorder();
    });
  };

  handlePreviousMonth = () => {
    const startOfPrevMonth = moment().subtract(1, 'months').startOf('month');
    const endOfPrevMonth = moment().subtract(1, 'months').endOf('month');

    this.setState({
      fromdate: startOfPrevMonth,
      todate: endOfPrevMonth,
      dateFilterApplied: true
    }, () => {
      this.refreshSalesorder();
    });
  };

  handleClearFilter = () => {
    this.setState({
      fromdate: moment().subtract(7, "days"),
      todate: moment(),
      dateFilterApplied: false
    }, () => {
      this.refreshSalesorder();
    });
  };

  getCurrentPageData() {
    const { filteredData, currentPage, itemsPerPage } = this.state;
    const sortedData = this.getSortedData(filteredData);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return sortedData.slice(indexOfFirstItem, indexOfLastItem);
  }

  handlePageChange(newPage) {
    this.setState({ currentPage: newPage });
  }

  handleItemsPerPageChange(e) {
    this.setState({
      itemsPerPage: parseInt(e.target.value),
      currentPage: 1
    });
  }

  handleReturnClick(returnItem) {
    this.setState({
      selectedReturn: returnItem,
      currentView: 'detail',
      hasScrolledToSelected: false
    }, () => {
      this.setState({
        filteredSidebarData: this.state.filteredData
      });
    });
  }

  handleBackToList() {
    this.setState({
      currentView: 'list',
      selectedReturn: null,
      hasScrolledToSelected: false
    }, () => {
      this.updateFilteredData();
    });
  }

  getCurrentTypeLabel() {
    return this.state.returntype;
  }

  getExportData() {
    const data = this.getCurrentData();
    return data.map(item => ({
      ...item,
      date: moment(item.date).format("DD-MM-YYYY HH:mm"),
      id: this.state.returntype === "Purchase Returns" ? item.custompoid : item.customgrnid
    }));
  }

  toggleExportDropdown() {
    this.setState(prevState => ({
      exportDropdownOpen: !prevState.exportDropdownOpen
    }));
  }

  closeExportDropdown() {
    this.setState({ exportDropdownOpen: false });
  }

  exportPDF() {
    this.closeExportDropdown();

    const data = this.getExportData();
    const curdate = moment().format('DD-MM-YYYY HH:mm:ss');
    const typeLabel = this.getCurrentTypeLabel();
    const dateFilterInfo = `${moment(this.state.fromdate).format("DD MMM YYYY")} - ${moment(this.state.todate).format("DD MMM YYYY")}`;

    // Create PDF in landscape mode
    const doc = new jsPDF('l', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const leftMargin = 15;
    const rightMargin = 10;
    const topMargin = 5;
    const bottomMargin = 10;
    const contentWidth = pageWidth - leftMargin - rightMargin;

    let yPosition = topMargin + 10;

    // Header
    doc.setFontSize(8);
    doc.setFont(undefined, 'bold');
    doc.text(clientname, leftMargin + 5, yPosition, {
      maxWidth: contentWidth * 0.9,
      align: 'left',
      overflow: 'linebreak'
    });

    const companyNameLines = doc.splitTextToSize(clientname, contentWidth * 0.9);
    const companyNameHeight = companyNameLines.length * 5;
    yPosition += companyNameHeight;

    // Document Title
    doc.setFontSize(7.5);
    doc.setFont(undefined, 'normal');
    doc.text(`${typeLabel}`, leftMargin + 5, yPosition);
    yPosition += 4;

    // Date Range
    doc.setFontSize(7);
    doc.setFont(undefined, 'normal');
    doc.text(`Date Range: ${dateFilterInfo}`, leftMargin + 5, yPosition);
    yPosition += 4;

    doc.text(`Export Date: ${curdate}`, leftMargin + 5, yPosition);
    yPosition += 5;

    // Table columns
    const columns = [
      { header: "ID", dataKey: 'id' },
      { header: "Supplier", dataKey: 'supplier' },
      { header: "Date", dataKey: 'date' }
    ];

    const tableData = data.map(item => {
      const row = {};
      columns.forEach(col => {
        row[col.dataKey] = item[col.dataKey] || '';
      });
      return row;
    });

    // Generate table
    autoTable(doc, {
      startY: yPosition,
      margin: { left: leftMargin, right: rightMargin, top: 10, bottom: bottomMargin },
      tableWidth: contentWidth,
      head: [columns.map(col => col.header)],
      body: tableData.map(item => columns.map(col => String(item[col.dataKey] || ''))),
      theme: 'grid',
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontSize: 7,
        fontStyle: 'bold',
        halign: 'center',
        valign: 'middle',
        cellPadding: 3,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      bodyStyles: {
        fontSize: 6,
        textColor: [0, 0, 0],
        cellPadding: 2,
        valign: 'middle',
        overflow: 'linebreak',
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      columnStyles: {
        2: { halign: 'center' }
      },
      didDrawPage: (data) => {
        const footerY = pageHeight - bottomMargin + 5;
        doc.setFontSize(7);
        const pageText = `Page ${data.pageNumber} of ${data.pageCount}`;
        const textWidth = doc.getTextWidth(pageText);
        doc.text(pageText, leftMargin + (contentWidth - textWidth) / 2, footerY);
      },
    });

    const filename = `${clientname}_${typeLabel.replace(/\s+/g, '_')}_${moment().format('DDMMYYYY_HHmm')}.pdf`;
    doc.save(filename);
  }

  renderTable() {
    const isMobile = this.state.isMobile;
    const currentPageData = this.getCurrentPageData();
    const isPurchaseReturns = this.state.returntype === "Purchase Returns";

    if (this.state.filteredData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {this.state.searchTerm ? `No ${this.state.returntype} found matching your search` : `No ${this.state.returntype} available`}
        </div>
      );
    }

    return (
      <>
        <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
          <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
            <thead className="UI-table-header">
              <tr>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'supplier' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('supplier')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Supplier
                    <this.SortIndicator columnKey="supplier" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === (isPurchaseReturns ? 'custompoid' : 'customgrnid') ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData(isPurchaseReturns ? 'custompoid' : 'customgrnid')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    {isPurchaseReturns ? 'PO ID' : 'GRN ID'}
                    <this.SortIndicator columnKey={isPurchaseReturns ? 'custompoid' : 'customgrnid'} />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'date' ? 'UI-th-sorted' : ''}`}
                  onClick={() => this.sortData('date')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Date
                    <this.SortIndicator columnKey="date" />
                  </div>
                </th>
                <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`} style={{ textAlign: 'center' }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {currentPageData.map((returnItem) => (
                <tr
                  key={returnItem.id || returnItem.poid || returnItem.grnid}
                  className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${this.state.hoveredRow === returnItem.id ? 'UI-table-row-hovered' : ''}`}
                  onClick={() => this.handleReturnClick(returnItem)}
                  onMouseEnter={() => this.setState({ hoveredRow: returnItem.id })}
                  onMouseLeave={() => {
                    this.setState({ hoveredRow: null, isActionHovered: null });
                  }}
                >
                  {/* SUPPLIER */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === returnItem.id ? 'UI-item-name-hover' : ''}`}
                  >
                    {(() => {
                      const name = returnItem.supplier || "";
                      const lastChar = name.slice(-1);
                      const rest = name.slice(0, -1);

                      return (
                        <>
                          <span>{this.highlightSearchText(rest, this.state.searchTerm)}</span>

                          <Tooltip
                            title="View Details"
                            placement="right"
                            arrow
                            slotProps={{
                              popper: {
                                sx: { pointerEvents: 'none' },
                              },
                            }}
                            open={
                              !this.state.isMobile &&
                              this.state.hoveredRow === returnItem.id &&
                              !this.state.isActionHovered
                            }
                          >
                            <span style={{ display: "inline-block" }}>
                              {this.highlightSearchText(lastChar, this.state.searchTerm)}
                            </span>
                          </Tooltip>
                        </>
                      );
                    })()}
                  </td>

                  {/* ID */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(
                      isPurchaseReturns ? returnItem.custompoid : returnItem.customgrnid,
                      this.state.searchTerm
                    )}
                  </td>

                  {/* DATE */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                  >
                    {this.highlightSearchText(
                      moment(returnItem.date).format('DD-MM-YYYY HH:mm'),
                      this.state.searchTerm
                    )}
                  </td>

                  {/* ACTION BUTTONS */}
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                    <div className="UI-action-buttons">
                      <Link
                        to={{ pathname: "/purchasereturnsdetails" }}
                        state={{
                          id: isPurchaseReturns ? returnItem.poid : returnItem.grnid,
                          pagename: isPurchaseReturns ? "Purchase Returns Details" : "GRN Returns Details",
                          returntype: isPurchaseReturns ? 0 : 1
                        }}
                        className={`UI-action-button ${isMobile ? 'UI-action-button-mobile' : ''} UI-edit-button`}
                        style={{ textDecoration: "none" }}
                        onClick={(e) => e.stopPropagation()}
                        onMouseEnter={() =>
                          this.setState({ isActionHovered: `view-${returnItem.id}` })
                        }
                        onMouseLeave={() => this.setState({ isActionHovered: null })}
                      >
                        <Tooltip title="View Details" arrow slotProps={{
                          popper: {
                            sx: { pointerEvents: 'none' },
                          },
                        }}>
                          <img
                            src={ViewIcon}
                            alt="View"
                            className={`UI-action-icon ${isMobile ? 'UI-action-icon-mobile' : ''} ${this.state.isActionHovered === `view-${returnItem.id}` ? 'UI-edit-icon-hover' : ''}`}
                          />
                        </Tooltip>
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {this.renderPagination()}
      </>
    );
  }

  renderTypeTabs() {
    const types = ["Purchase Returns", "GRN Item Returns"];

    return (
      <div
        className="UI-tabs-row"
        style={{
          marginBottom: "16px",
          marginTop: "10px",
          marginLeft: "10px",
        }}
      >
        {types.map((tabType) => (
          <TabButton
            key={tabType}
            active={this.state.returntype === tabType}
            onClick={() =>
              this.setState(
                {
                  returntype: tabType,
                  currentView: 'list',
                  selectedReturn: null,
                  sortConfig: { key: 'supplier', direction: 'asc' }
                },
                this.updateFilteredData
              )
            }
          >
            {tabType}
          </TabButton>
        ))}
      </div>
    );
  }

  renderDateFilters() {
    const isMobile = this.state.isMobile;

    return (
      <div className="UI-date-filter-container">
        {/* LEFT SIDE: Clear button and Prev Month button */}
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginLeft: 'auto' }}>
          {/* MIDDLE: Selected date range display (only when filter is applied) */}
          {this.state.dateFilterApplied && (
            <div className={`UI-selected-date-range ${isMobile ? 'UI-selected-date-range-mobile' : ''}`}>
              <i className="fa fa-calendar-check" style={{ fontSize: '0.7rem', marginRight: '4px', color: '#4f46e5' }} />
              {moment(this.state.fromdate).format("DD MMM YYYY")} - {moment(this.state.todate).format("DD MMM YYYY")}
              <button
                className="UI-date-range-close"
                onClick={this.handleClearFilter}
                onMouseEnter={() => this.setState({ hovered: 'dateRangeClose' })}
                onMouseLeave={() => this.setState({ hovered: null })}
                aria-label="Clear date filter"
              >
                <i className="fa fa-times" style={{ fontSize: '0.7rem' }} />
              </button>
            </div>
          )}

          <button
            className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "prevMonth" ? 'UI-btn-outline-hover' : ''}`}
            onClick={this.handlePreviousMonth}
            onMouseEnter={() => this.setState({ hovered: 'prevMonth' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            <i className="fa fa-calendar" style={{ fontSize: '0.7rem' }} />
            Prev Month
          </button>
        </div>



        {/* RIGHT SIDE: Date pickers and Apply button */}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <DatePicker
              label="From Date"
              value={this.state.fromdate}
              onChange={this.handleFromDateChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  style={{ width: '140px' }}
                />
              )}
            />
            <span style={{ color: '#64748b', fontSize: '0.8rem' }}>to</span>
            <DatePicker
              label="To Date"
              value={this.state.todate}
              onChange={this.handleToDateChange}
              minDate={this.state.fromdate}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  style={{ width: '140px' }}
                />
              )}
            />
          </div>
        </LocalizationProvider>
        <button
          className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "apply" ? 'UI-btn-outline-hover' : ''}`}
          onClick={this.handleDateFilter}
          onMouseEnter={() => this.setState({ hovered: 'apply' })}
          onMouseLeave={() => this.setState({ hovered: null })}
        >
          <i className="fa fa-filter" style={{ fontSize: '0.7rem' }} />
          Apply
        </button>
      </div>
    );
  }

  renderPagination() {
    const { filteredData, currentPage, itemsPerPage, isMobile } = this.state;

    if (filteredData.length <= itemsPerPage) return null;

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    return (
      <div className={`UI-pagination-container ${isMobile ? 'UI-pagination-container-mobile' : ''}`}>
        <div className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
          Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, filteredData.length)} of {filteredData.length} records
        </div>
        <div className={`UI-pagination-controls ${isMobile ? 'UI-pagination-controls-mobile' : ''}`}>
          <TextField
            select
            value={itemsPerPage}
            onChange={this.handleItemsPerPageChange}
            variant="outlined"
            size="small"
            className={`UI-page-size-select ${isMobile ? 'UI-page-size-select-mobile' : ''} ${this.state.hovered === 'pagesize' ? 'UI-page-size-select-hover' : ''}`}
            onMouseEnter={() => this.setState({ hovered: 'pagesize' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            <MenuItem value={5}>5 per page</MenuItem>
            <MenuItem value={10}>10 per page</MenuItem>
            <MenuItem value={20}>20 per page</MenuItem>
            <MenuItem value={50}>50 per page</MenuItem>
          </TextField>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'first' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'first' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'First' : 'First'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'prev' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'prev' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Prev' : 'Previous'}
          </button>

          <span className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'next' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'next' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Next' : 'Next'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'last' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'last' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Last' : 'Last'}
          </button>
        </div>
      </div>
    );
  }

  renderDetailView() {
    const { selectedReturn, filteredSidebarData } = this.state;
    if (!selectedReturn) return null;

    const isPurchaseReturns = this.state.returntype === "Purchase Returns";

    return (
      <div className="UI-detail-view">
        {/* Sidebar */}
        <div className="UI-sidebar">
          <div className="UI-sidebar-header">
            <button
              className={`UI-back-button ${this.state.hovered === 'back' ? 'UI-back-button-hover' : ''}`}
              onClick={this.handleBackToList}
              onMouseEnter={() => this.setState({ hovered: 'back' })}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              <i className="fa fa-arrow-left" /> Back
            </button>
          </div>
          <div className="UI-sidebar-list" ref={this.sidebarRef}>
            {filteredSidebarData.map((returnItem) => (
              <div
                key={returnItem.id}
                data-return-id={returnItem.id}
                className={`UI-sidebar-item ${selectedReturn.id === returnItem.id ? 'UI-sidebar-item-active' : ''} ${this.state.hovered === returnItem.id ? 'UI-sidebar-item-hover' : ''}`}
                onClick={() => this.setState({ selectedReturn: returnItem })}
                onMouseEnter={() => this.setState({ hovered: returnItem.id })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                <div className={`UI-sidebar-item-name ${this.state.hovered === returnItem.id ? 'UI-sidebar-item-name-hover' : ''}`}>
                  {this.highlightSearchText(returnItem.supplier, this.state.searchTerm)}
                </div>
                <div className={`UI-sidebar-item-code ${this.state.hovered === returnItem.id ? 'UI-sidebar-item-code-hover' : ''}`}>
                  {this.highlightSearchText(
                    isPurchaseReturns ? returnItem.custompoid : returnItem.customgrnid,
                    this.state.searchTerm
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Detail Content */}
        <div className="UI-detail-content">
          <div className="UI-detail-header">
            <div className="UI-detail-title-wrapper">
              <h2 className="UI-detail-title">{selectedReturn.supplier}</h2>
              <p className="UI-detail-subtitle">
                {isPurchaseReturns ? 'PO' : 'GRN'} ID: {isPurchaseReturns ? selectedReturn.custompoid : selectedReturn.customgrnid}
              </p>
            </div>
            <div className="UI-detail-actions">
              <Link
                to={{ pathname: "/purchasereturnsdetails" }}
                state={{
                  id: isPurchaseReturns ? selectedReturn.poid : selectedReturn.grnid,
                  pagename: isPurchaseReturns ? "Purchase Returns Details" : "GRN Returns Details",
                  returntype: isPurchaseReturns ? 0 : 1
                }}
                className={`UI-detail-action-button UI-detail-edit-button ${this.state.hovered === "view" ? 'UI-edit-button-hover' : ''}`}
                style={{ textDecoration: "none" }}
                onMouseEnter={() => this.setState({ hovered: "view" })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                <Tooltip title="View Details" arrow>
                  <img
                    src={ViewIcon}
                    alt="View"
                    className={`UI-action-icon ${this.state.hovered === "view" ? 'UI-action-icon-hover' : ''}`}
                  />
                </Tooltip>
              </Link>
            </div>
          </div>
          <div className="UI-detail-grid">
            {/* Basic Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Basic Information</h3>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Supplier</span>
                <span className="UI-detail-value">{selectedReturn.supplier}</span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">{isPurchaseReturns ? 'PO ID' : 'GRN ID'}</span>
                <span className="UI-detail-value">
                  {isPurchaseReturns ? selectedReturn.custompoid : selectedReturn.customgrnid}
                </span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Return Type</span>
                <span className="UI-detail-value">
                  <span className={`UI-status-badge UI-status-${isPurchaseReturns ? 'purchase-return' : 'grn-return'}`}>
                    {isPurchaseReturns ? 'Purchase Return' : 'GRN Return'}
                  </span>
                </span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Date</span>
                <span className="UI-detail-value">
                  {moment(selectedReturn.date).format("DD-MM-YYYY HH:mm")}
                </span>
              </div>
            </div>

            {/* Additional Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Additional Information</h3>
              {isPurchaseReturns && selectedReturn.poid && (
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Original PO ID</span>
                  <span className="UI-detail-value">{selectedReturn.poid}</span>
                </div>
              )}
              {!isPurchaseReturns && selectedReturn.grnid && (
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Original GRN ID</span>
                  <span className="UI-detail-value">{selectedReturn.grnid}</span>
                </div>
              )}
              {selectedReturn.supplierid && (
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Supplier ID</span>
                  <span className="UI-detail-value">{selectedReturn.supplierid}</span>
                </div>
              )}
              {selectedReturn.totalprice && (
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Total Price</span>
                  <span className="UI-detail-value">{this.formatCurrency(selectedReturn.totalprice)}</span>
                </div>
              )}
              {selectedReturn.taxamount && (
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Tax Amount</span>
                  <span className="UI-detail-value">{this.formatCurrency(selectedReturn.taxamount)}</span>
                </div>
              )}
            </div>

            {/* Date Range Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Date Range Information</h3>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Filtered Date Range</span>
                <span className="UI-detail-value">
                  {moment(this.state.fromdate).format("DD MMM YYYY")} - {moment(this.state.todate).format("DD MMM YYYY")}
                </span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Record Date</span>
                <span className="UI-detail-value">
                  {moment(selectedReturn.date).format("DD MMM YYYY")}
                </span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Days Since Return</span>
                <span className="UI-detail-value">
                  {moment().diff(moment(selectedReturn.date), 'days')} days
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderListView() {
    return (
      <>
        {this.renderTypeTabs()}
        {this.renderDateFilters()}
        {this.renderTable()}
      </>
    );
  }

  render() {
    const isMobile = this.state.isMobile;

    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className={`UI-container ${isMobile ? 'UI-container-mobile' : ''}`}>
            <div className="UI-card">
              {/* Header */}
              <div className={`UI-header ${isMobile ? 'UI-header-mobile' : ''}`}>
                <nav className={`UI-breadcrumb ${isMobile ? 'UI-breadcrumb-mobile' : ''}`}>
                  <Link
                    to="/purchase"
                    className={`UI-breadcrumb-item ${this.state.hovered === 'home' ? 'UI-breadcrumb-item-hover' : ''}`}
                    onMouseEnter={() => this.setState({ hovered: 'home' })}
                    onMouseLeave={() => this.setState({ hovered: null })}
                  >
                    Home
                  </Link>
                  <span>/</span>
                  <span className={`UI-breadcrumb-item UI-breadcrumb-active`}>
                    Purchase Returns
                  </span>
                </nav>
                <div className={`UI-header-content ${isMobile ? 'UI-header-content-mobile' : ''}`}>
                  <div>
                    <h1 className={`UI-title ${isMobile ? 'UI-title-mobile' : ''}`}>Purchase Returns</h1>
                    <p className={`UI-subtitle ${isMobile ? 'UI-subtitle-mobile' : ''}`}>
                      {this.state.currentView === 'detail' && this.state.selectedReturn
                        ? `${this.state.returntype}: ${this.state.returntype === "Purchase Returns" ? this.state.selectedReturn.custompoid : this.state.selectedReturn.customgrnid}`
                        : 'Manage purchase returns and GRN item returns'
                      }
                    </p>
                  </div>
                  <div className={`UI-header-actions ${isMobile ? 'UI-header-actions-mobile' : ''}`}>
                    {/* Desktop Search */}
                    {!isMobile && (
                      <div
                        className={`UI-search-container ${this.state.showSearch ? 'UI-search-container-expanded' : ''} ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`}
                        onClick={() => {
                          if (!this.state.showSearch) this.setState({ showSearch: true });
                        }}
                        onMouseEnter={() => this.setState({ hovered: "search" })}
                        onMouseLeave={() => this.setState({ hovered: null })}
                      >
                        <i className={`fa fa-search UI-search-icon ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`} />
                        {!this.state.showSearch && "Search"}
                        {this.state.showSearch && (
                          <input
                            type="text"
                            className="UI-search-input"
                            placeholder="Search returns..."
                            value={this.state.searchTerm}
                            onChange={(e) => this.handleSearch(e.target.value)}
                            autoFocus
                            onClick={(e) => e.stopPropagation()}
                            onBlur={() => {
                              if (this.state.searchTerm.trim() === "") {
                                this.setState({ showSearch: false });
                              }
                            }}
                          />
                        )}
                      </div>
                    )}
                    {/* Mobile Search */}
                    {isMobile && (
                      <input
                        type="text"
                        className="UI-mobile-search-input"
                        placeholder="Search returns..."
                        value={this.state.searchTerm}
                        onChange={(e) => this.handleSearch(e.target.value)}
                      />
                    )}
                    {/* Export dropdown */}
                    {(purchaseid === '2' || purchaseid === '3') && (
                      <div className="UI-export-container" ref={this.exportRef}>
                        <button
                          className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "export" ? 'UI-btn-outline-hover' : ''}`}
                          onClick={this.toggleExportDropdown}
                          onMouseEnter={() => this.setState({ hovered: "export" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i className="fa fa-file-export" /> {isMobile ? "Export" : "Export"}
                          <i className="fa fa-caret-down" style={{ marginLeft: '4px' }} />
                        </button>
                        {this.state.exportDropdownOpen && (
                          <div className="UI-export-dropdown">
                            <button
                              className="UI-export-option"
                              onClick={this.exportPDF}
                              onMouseEnter={() => this.setState({ hovered: "exportPDF" })}
                              onMouseLeave={() => this.setState({ hovered: null })}
                            >
                              <i className="fa fa-file-pdf" /> PDF Export
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                    {/* New Return button */}
                    {(purchaseid === '2' || purchaseid === '3') && (
                      <Link
                        to={{ pathname: "/newpurchasereturn" }}
                        state={{
                          id: -1,
                          returntype: this.state.returntype === "Purchase Returns" ? 0 : 1,
                          pagename: this.state.returntype === "Purchase Returns" ? "New Purchase Returns" : "New GRN Returns"
                        }}
                        className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-primary ${this.state.hovered === "new" ? 'UI-btn-primary-hover' : ''}`}
                        style={{ textDecoration: "none" }}
                        onMouseEnter={() => this.setState({ hovered: "new" })}
                        onMouseLeave={() => this.setState({ hovered: null })}
                      >
                        <i className="fa fa-plus" /> {isMobile ? "New" : "New Return"}
                      </Link>
                    )}
                  </div>
                </div>
              </div>

              {this.state.loading ? (
                <div className="UI-loading-container">
                  {spin}
                </div>
              ) : (
                <div style={{ marginTop: '8px' }}>
                  {this.state.currentView === 'list'
                    ? this.renderListView()
                    : this.renderDetailView()
                  }
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(PurchaseReturns);